import BaseApi from '../base/base'
import Material from '../../models/material'
import Lesson from '../../models/lesson'

export default class LessonApi extends BaseApi {
  constructor() {
    super()
    this.path = '/lessons'
  }

  async show(params = { lessonId: '0'}, requestMode = 'default' ) {
    this.path = `/lessons/${params.lessonId}?request_mode=${requestMode}`
    const response = await this.getRequest(params)
    return new Lesson(response.data)
  }

  async materials(params = { lessonId: '0' }) {
    this.path = `/lessons/${params.lessonId}/materials`
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new Material(element)
    })
  }

  async learnt(params = { courseId: '0', lessonId: '0' }) {
    this.path = `/courses/${params.courseId}/lessons/${params.lessonId}/learnt`
    const response = await this.postRequest(params)
    return response.data
  }

  async revertLearnt(params = { courseId: '0', lessonId: '0' }) {
    this.path = `/courses/${params.courseId}/lessons/${params.lessonId}/revert_learnt`
    const response = await this.postRequest(params)
    return response.data
  }
}
